import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const putInstituicao = async (
  token: string,
  cnpj: string,
  status: string,
  observacao?: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.put(`${API_URL}/instituicoes/${cnpj}`, { status, observacao }, config);
  return response.data;
};
export default putInstituicao;
